export const actionTypes = {
    ACTIVATE_DEACTIVATE_GATEWAY_SETTINGS: 'powertrainTools/gatewayManagement/ACTIVATE_DEACTIVATE_GATEWAY_SETTINGS',
    ACTIVATE_DEACTIVATE_GATEWAY: 'powertrainTools/gatewayManagement/ACTIVATE_DEACTIVATE_GATEWAY',
    LAST_COMMAND_ACTIVATE_ACTION_SETTINGS: 'powertrainTools/gatewayManagement/LAST_COMMAND_ACTIVATE_ACTION_SETTINGS',
    LAST_COMMAND_ACTIVATE_ACTION: 'powertrainTools/gatewayManagement/LAST_COMMAND_ACTIVATE_ACTION',
    CLEAR_LAST_COMMAND_STATUS: 'powertrainTools/gatewayManagement/CLEAR_LAST_COMMAND_STATUS',
    CLEAR_STORE: 'powertrainTools/gatewayManagement/activateDeactivateGateway/CLEAR_STORE'
};

export const requestType = {
    DEACTIVATED_REMOTE_CONNECTION: 'DeActivateNetaRemoteConnection',
    ACTIVATED_REMOTE_CONNECTION: 'ActivateNetaRemoteConnection'
};
